/**
 * Reducer helper for the `fetchBranding` success action.
 *
 * @method fetchBrandingSuccess
 * @param  {Object}              state  The 'branding' state
 * @param  {Object}              action The fired action
 * @return {Object}                     The updated state
 */
export const fetchBrandingSuccess = (state, action) => {
    return {
        ...state,
        ...action.payload
    };
};
